import { useState } from 'react'

import { Grid } from '@mui/material'
import axios from 'axios'

import MDBox from 'components/MDBox'
import { useAuth } from 'context/auth'
import DashboardLayout from 'modules/LayoutContainers/DashboardLayout'
import ManageCard from 'modules/ManageCard'
import DashboardNavbar from 'modules/Navbars/DashboardNavbar'

import MainForm from './components/MainForm'
import { initUserForm, UserFormContext } from './constants'

function NewUserForm() {
	const { user } = useAuth()

	const [userForm, setUserForm] = useState(initUserForm)
	const [formEdited, setFormEdited] = useState<boolean>(false)
	const [showError, setShowError] = useState<boolean>(false)
	const [isValid, setIsValid] = useState<boolean>(true)

	const createNewFirebaseUser = async () => {
		try {
			await axios.post<{ message: string; quantity: number }>(
				`${process.env.REACT_APP_API_URL}/account/user`,
				{
					email: userForm.email,
					role: userForm.role,
					name: userForm.name,
				},
				{
					headers: {
						Authorization: await user.auth.getIdToken(),
					},
				}
			)
		} catch (error: any) {
			console.error('❌ Error creating user:', error.message)
			throw error
		}
	}
	return (
		<UserFormContext.Provider
			value={{
				userForm,
				setUserForm,
				formEdited,
				setFormEdited,
				showError,
				setShowError,
				isValid,
				setIsValid,
			}}
		>
			<DashboardLayout>
				<DashboardNavbar isMini />
				<MDBox mt={4}>
					<Grid container spacing={3}>
						<Grid item xs={12} lg={9}>
							<MDBox mb={3}>
								<MainForm />
							</MDBox>
						</Grid>
						<Grid item xs={12} lg={3}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<ManageCard
										formEdited={formEdited}
										setFormEdited={setFormEdited}
										save={{
											onClicked: async () => {
												if (!isValid) {
													setShowError(true)
													return
												}
												await createNewFirebaseUser()
											},
										}}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</MDBox>
			</DashboardLayout>
		</UserFormContext.Provider>
	)
}

export default NewUserForm
